import useCallApi from '../../utilities/axios'

export type ClosedByTermKeyword = {
    keyword?: string
    termYear?: number | null
    userID: number | null
}

export type ClosedByTerm = {
    projectID: number
    projectNumber: string
    closedDate: string
    receiveDate: string
    projectName: Translation
    projectType: {
        id: number
        name: Translation
    }
    name: Translation
    title: Translation
    titleID: number
    academicPosition: Translation
    isPhD: boolean
    researcherTypeName: Translation
}

type Translation = {
    th: string
    en: string
}

export type deleteProjectCloseRequest = {
    projectIDs: number[]
}

export const useSearchClosedByTerm = () => {
    const callApi = useCallApi()

    const searchClosedByTerm = async (values: ClosedByTermKeyword) => {
        const { data } = await callApi.axiosPost({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/dashboard/search/project/closed-by-term`,
            params: { ...values },
        })

        return data
    }

    const deleteProjectClose = async (values: deleteProjectCloseRequest) => {
        const queryString = values.projectIDs.map((id, index) => `projectIDs[${index}]=${id}`).join('&')

        const { data } = await callApi.axiosDelete({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/project/delete-project-close?${queryString}`,
        })

        return data
    }

    return {
        searchClosedByTerm,
        deleteProjectClose,
    }
}
